module.exports = __webpack_public_path__ + "static/media/KaitlinYang_Header.5a893368.jpg";